import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import { Input } from 'reactstrap';
import classnames from 'classnames';
import useReadOnly from './useReadOnly';

const SelectSegCus = (props) => {
  const { values, submitForm, isSubmitting, isValid, setFieldValue } = useFormikContext();
  const [field, meta] = useField(props);
  const readOnly = props.readOnly;
  let { name, options, invalid, type } = props;
  const [isCheckCon, setIsCheckCon] = useState(true);

  options = React.useMemo(
    () =>
      options?.filter((o) => {
        let opts1 = readOnly ? !o.value || o.value === meta.value : !o.readOnly;
        let rs = o.value !== values?.customerSourceTwo && o.value !== values?.customerSourceThree || o.value === '';
        if (type === 2)
          rs = (o.value !== values?.customerSource && o.value !== values?.customerSourceThree) || o.value === '';
        if (type === 3)
          rs = (o.value !== values?.customerSource && o.value !== values?.customerSourceTwo) || o.value === '';
        return opts1 && rs;
      }),
    [options, readOnly, meta.value, values?.customerSource, values?.customerSourceTwo, values?.customerSourceThree],
  );

  useEffect(() => {
    if (type === 2) {
      if (!values?.customerSource || values?.customerSource === '') {
        setFieldValue('customerSourceTwo', null);
        setFieldValue('customerSourceThree', null);
        setIsCheckCon(false);
      } else {
        setIsCheckCon(true);
      }
    }
    if (type === 3) {
      if (!values?.customerSourceTwo || values?.customerSourceTwo === '') {
        setFieldValue('customerSourceThree', null);
        setIsCheckCon(false);
      } else {
        setIsCheckCon(true);
      }
    }
  }, [values?.customerSource, values?.customerSourceTwo, values?.customerSourceThree]);

  return (
    <Input
      {...field}
      value={field.value || ''}
      id={name}
      type='select'
      disabled={readOnly || !isCheckCon}
      invalid={invalid || (meta.error && meta.touched)}
      className={classnames(props.className)}
    >
      {(options || []).map((o, i) => (
        <option key={`${o.value}_${i}`} value={o.value}>
          {o.label}
        </option>
      ))}
    </Input>
  );
};

SelectSegCus.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      readOnly: PropTypes.bool,
    }),
  ),
  readOnly: PropTypes.bool,
  invalid: PropTypes.any,
};

export default SelectSegCus;
